import { PetAttributeSuffix as Container } from "./styles";

export function PetCardAttributeSuffix({ label }) {
  if (label === "Peso" || label === "PetPeso") {
    return <Container>kg</Container>;
  }
  return null;
}
